import * as React from 'react';
import { useOutletContext } from 'react-router-dom';

export default function Error() {
    const errorMsg = useOutletContext().errorMsg;
    return <div>{errorMsg}</div>;
}
